import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Alert, Steps, Switch as Toggle } from 'antd'
import Practice from './Practice'
import Products from './Products'
import Users from './Users'
import Info from './Info'
import Associations from './Associations'
import { newPracticeStorage } from '../services/localStorage'
import css from './index.css'
import {
  buyPhoneNumber,
  createAdmin,
  createBusiness,
  createDoctor,
  createLocation,
  createPbx,
  createPractice,
  deleteBusiness, //  TODO build this out later
  getAdAccounts,
  getAppointmentTypes,
  getCarestreamCustomers,
  getCustomMentionValues,
  updateCustomMentionValues,
  getDoctors,
  getExtensions,
  getExternalOutboundNumbers,
  getLocations,
  getPbx,
  getAdAccountIdsForPractice,
  getRemoteDatabases,
  getUsers,
  removeUser,
  showPractice,
  updateAdAccountIdsForPractice,
  updateAdmin,
  updateBusiness,
  updateDoctor,
  updateExtensions,
  updateLocation,
  updatePbx,
  updatePractice,
} from '../common/requests'
import { formatPhoneNumberForUpdate } from '../services/utils'

const { Step } = Steps

class AddPractice extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    practiceId: PropTypes.string,
    savePracticeId: PropTypes.func.isRequired,
    signout: PropTypes.func.isRequired,
  }
  static defaultProps = {
    practiceId: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      additionalRecipients: null,
      appointmentTypes: [],
      businessArrayId: null,
      businesses: [],
      checksReady: false,
      customMentionValuesByLocation: {},
      doctors: [],
      editingBusiness: null,
      error: null,
      extensions: {},
      externalId: null,
      externalOutboundNumbers: [],
      isBusinessFormOpen: false,
      locations: [],
      messageReportEmail: null,
      pbxDomain: null,
      pbxNumber: null,
      pbxServiceType: null,
      pbxUsername: null,
      pbxVEmail: null,
      pms: null,
      pmsIntegration: false,
      practiceName: null,
      products: [],
      servicesCancelled: false,
      subdirectory: null,
      tier: null,
      users: [],
      website: null,
      adAccounts: [],
      adAccountIdsForPractice: [],
      greyfinchIntegrationComplete: false,
    }
    this.createAdminUser = this.createAdminUser.bind(this)
    this.updateAdminUser = this.updateAdminUser.bind(this)
  }

  async componentWillMount() {
    try {
      const { practiceId, isTopsAdmin } = this.props
      const { pms } = this.state
      const nextState = { checksReady: true }
      if (practiceId) {
        const {
          businesses,
          practice,
          products,
          patient_portal_token: patientPortalToken,
        } = await showPractice(practiceId)

        // asign new values to the next state obj
        nextState.additionalRecipients = practice.additional_report_recipients
        nextState.businesses = businesses
        nextState.externalId = practice.external_id
        nextState.messageReportEmail = practice.message_report_email
        nextState.pms = practice.pms_type
        nextState.pmsIntegration = !!practice.pms_type
        nextState.practiceName = practice.name
        nextState.servicesCancelled = practice.services_cancelled
        nextState.products = products
        nextState.subdirectory = patientPortalToken
          ? patientPortalToken.subdirectory
          : null
        nextState.tier = practice.tier

        const extensionData = await getExtensions(practiceId)
        nextState.extensions = extensionData

        const pbxData = await getPbx(practiceId)
        if (pbxData.length > 0) {
          const { id, number, username, voicemail_email, service_type, domain } = pbxData[0]
          nextState.pbxId = id
          nextState.pbxNumber = number.toString()
          nextState.pbxUsername = username
          nextState.pbxVEmail = voicemail_email
          nextState.pbxServiceType = service_type
          nextState.pbxDomain = domain
        }

        const userData = await getUsers(practiceId)
        nextState.users = this.filterPracticeAdmins(userData)

        const locationData = await getLocations(practiceId)
        nextState.locations = locationData
        const location = locationData[0]

        const customMentionValuesData = await getCustomMentionValues(practiceId)
        nextState.customMentionValuesByLocation = customMentionValuesData

        const apptTypes = await getAppointmentTypes(practiceId)
        nextState.appointmentTypes = apptTypes

        if (practice.pms_type === 'OrthoTracV2') {
          const carestreamCustomers = await getCarestreamCustomers()
          nextState.carestreamCustomers = carestreamCustomers
        }

        if (practice.pms_type === 'Greyfinch') {
          const externalOutboundNumbers = await getExternalOutboundNumbers(practiceId)
          nextState.externalOutboundNumbers = externalOutboundNumbers
          const remoteDatabases = await getRemoteDatabases(practiceId)
          nextState.greyfinchIntegrationComplete = remoteDatabases.length > 0 && 
            remoteDatabases[0].key && remoteDatabases[0].secret
        }

        if (location) {
          nextState.website = location.website
        }

        if (products.includes('crm')) {
          const adAccounts = await getAdAccounts()
          const adAccountIdsForPractice = await getAdAccountIdsForPractice(practiceId)
          nextState.adAccounts = adAccounts
          nextState.adAccountIdsForPractice = adAccountIdsForPractice
        }

        if (pms === null) {
          const doctorData = await getDoctors(practiceId)
          nextState.doctors = doctorData
          this.setState({ ...nextState })
        } else {
          this.setState({ ...nextState })
        }
      } else {
        this.setState({
          checksReady: true,
          products: isTopsAdmin ? ['reminders'] : [],
          pms: isTopsAdmin ? 'topsOrtho' : null,
          pmsIntegration: isTopsAdmin,
        })
      }
    } catch (e) {
      this.handleApiError(e)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { practiceId: oldPracticeId } = this.props
    const { isTopsAdmin, practiceId } = nextProps
    if (!practiceId && oldPracticeId) {
      this.setState({
        additionalRecipients: null,
        appointmentTypes: [],
        businesses: [],
        externalId: null,
        locations: [],
        messageReportEmail: null,
        pbxDomain: null,
        pbxId: null,
        pbxNumber: null,
        pbxServiceType: null,
        pbxUsername: null,
        pbxVEmail: null,
        pms: isTopsAdmin ? 'topsOrtho' : null,
        practiceName: null,
        products: isTopsAdmin ? ['reminders'] : [],
        servicesCancelled: false,
        tier: null,
        users: [],
        website: null,
        adAccountIdsForPractice: [],
        greyfinchIntegrationComplete: false,
      })
    }
  }

  async refreshUsers() {
    const userData = await getUsers(this.props.practiceId)
    this.setState({ users: this.filterPracticeAdmins(userData) })
  }

  setDefaultState = isTopsAdmin =>
    this.setState({
      checksReady: true,
      products: isTopsAdmin ? ['reminders'] : [],
      pms: isTopsAdmin ? 'topsOrtho' : null,
    })

  checkGreyfinchIntegration = () => {
    const { pms, greyfinchIntegrationComplete } = this.state
    if (pms !== 'Greyfinch') {
      return true
    }
    return greyfinchIntegrationComplete
  }

  steps = [
    {
      title: 'Practice',
      completed: () => !!this.state.practiceName,
    },
    {
      title: 'Products',
      completed: () =>
        !!(
          this.steps[0].completed() &&
          this.state.products.length &&
          this.state.tier
        ),
    },
    {
      title: 'Users',
      completed: () => !!(this.steps[1].completed() && this.state.users.length),
    },
    {
      title: 'Info',
      completed: () =>
        !!(this.steps[2].completed() && this.state.locations.length && this.checkGreyfinchIntegration()),
    },
    {
      title: 'Associations',
      completed: () =>
        !!(this.steps[3].completed() && this.checkLocationInfo()),
    },
  ]

  handleApiError = err => {
    if ('body' in err && err.body.error === 'unauthorized') {
      this.props.signout()
    } else {
      const error = err.message || err.statusText
      this.setState({
        error,
      })
    }
  }

  clearError = () => {
    this.setState({
      error: null,
    })
  }

  // pass down this method to child components if want to save to root state obj
  handleNamedInputChange = ({ target: { value, name } }) => {
    let inputValue = value
    if (name === 'subdirectory') inputValue = value.trim()
    if (name === 'pbxNumber') {
      const isOnlyNumbers = new RegExp('^[0-9]+$')
      if (
        value.length &&
        (value[0] === '0' || !isOnlyNumbers.test(value[value.length - 1]))
      ) {
        return
      }
    }
    this.setState({
      [name]: inputValue,
    })
  }

  validateEmail = email =>
    !email.includes('spvoicemail') &&
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)

  // step 1 on next
  handleStep1Next = () => {
    const { practiceId } = this.props
    const { practiceName, externalId } = this.state
    if (practiceId) {
      updatePractice(practiceId, {
        name: practiceName,
        external_id: externalId,
      }).then(this.next)
    } else {
      this.next()
    }
  }

  toggleCancelled = () => {
    const { practiceId } = this.props
    if (practiceId) {
      updatePractice(practiceId, {
        toggle_cancelled: true,
      })
        .then(res => {
          this.setState({
            servicesCancelled: res.practice.services_cancelled,
          })
        })
        .catch(err => {
          this.handleApiError(err)
          return Promise.resolve()
        })
    }
  }

  createOrUpdateLocation = (body, locationId) => {
    this.clearError()
    const { practiceId } = this.props
    const requestPromise = locationId
      ? updateLocation(practiceId, locationId, body)
      : createLocation(practiceId, body)
    return requestPromise
      .then(() => this.getAndSaveLocationList())
      .catch(err => {
        this.handleApiError(err)
        return Promise.resolve()
      })
  }

  updateLocationsWebsite = (website, practiceId) => {
    const locationBody = { website }
    getLocations(practiceId).then(res => {
      res.forEach(location => {
        this.createOrUpdateLocation(locationBody, location.id)
      })
    })
  }

  onProductSelect = ({ target: { value } }) => {
    const { products } = this.state
    const index = products.indexOf(value)
    if (index < 0) {
      products.push(value)
    } else {
      products.splice(index, 1)
    }
    if (
      (products.includes('reminderstier2') ||
        products.includes('topsremindersplus')) &&
      !products.includes('reminders')
    ) {
      products.push('reminders')
    }
    if (!products.includes('reminders')) {
      this.setState({
        tier: 1,
      })
    }
    if (products.includes('dso') && products.includes('crm')) {
      products.splice(products.indexOf('crm'), 1)
      this.setState({
        products,
      })
    }
    if (
      products.includes('missedcalltext') &&
      !products.includes('voip')
    ) {
      products.push('voip')
    }
    this.setState({
      products,
    })
  }

  updatePmsInState = (val, callback) => {
    const { isTopsAdmin } = this.props
    let pms
    if (!val) {
      pms = null
    } else {
      pms = isTopsAdmin ? 'topsOrtho' : val
    }
    this.setState({
      pms,
    }, callback)
  }

  unselectIneligibleProducts = productsToFilter => {
    const { products } = this.state
    this.setState({
      products: products.filter(product => productsToFilter.includes(product)),
    })
  }

  // step 2 on next
  // Note: when running locally, make sure 'reminders' and 'openchair' are added as products to db
  handleStep2Next = () => {
    this.clearError()
    const { practiceId } = this.props
    const {
      additionalRecipients,
      businesses,
      externalId,
      messageReportEmail,
      pbxDomain,
      pbxId,
      pbxNumber,
      pbxServiceType,
      pbxUsername,
      pbxVEmail,
      pms,
      practiceName,
      products,
      subdirectory,
      tier,
      website,
      adAccountIdsForPractice,
    } = this.state
    const body = {
      additional_report_recipients: additionalRecipients,
      external_id: externalId,
      message_report_email: messageReportEmail,
      name: practiceName,
      pms_type: pms,
      products,
      subdirectory,
      tier,
    }
    const pbx = {
      domain: pbxDomain,
      number: pbxNumber,
      service_type: pbxServiceType,
      username: pbxUsername,
      voicemail_email: pbxVEmail === '' ? null : pbxVEmail,
    }
    const requestPromise = practiceId
      ? updatePractice(practiceId, body)
      : createPractice(body)
    return requestPromise
      .then(res => {
        const { practice, products: resProducts } = res
        this.props.savePracticeId(practice.id)

        // if the practice already existed, update its locations' website field
        if (practiceId && resProducts.includes('openchair') && website) {
          this.updateLocationsWebsite(website, practiceId)
        }

        // if practice has openchair fetch appointment_types if they want a custom_filter
        if (practiceId && resProducts.includes('openchair')) {
          this.getAndSaveAppointmentTypes(practiceId)
        }

        // if practice is orthotracv2 fetch carestream customers for dropdown in step 4
        if (practiceId && pms === 'OrthoTracV2') {
          this.getAndSaveCarestreamCustomers()
        }

        if (practiceId) {
          pbxId ? updatePbx(practiceId, pbxId, pbx) : createPbx(practiceId, pbx)
        }

        if (practiceId && !resProducts.includes('dso')) {
          this.refreshUsers()
        }

        if (!practiceId && businesses.length) {
          Promise.all(
            businesses.map(business => createBusiness(practice.id, business)),
          ).then(() => this.getAndSaveBusinessList(practice))
        }

        if (practiceId && products.includes('crm')) {
          this.updateAdAccountsForPractice(practiceId, adAccountIdsForPractice)
        }

        this.setState(
          {
            additionalRecipients: practice.additional_report_recipients,
            messageReportEmail: practice.message_report_email,
            pms: practice.pms_type,
            practiceName: practice.name,
            products: resProducts,
            tier: practice.tier,
          },
          this.next,
        )
      })
      .catch(err => {
        this.handleApiError(err)
      })
  }

  updateAdAccountsForPractice = (practiceId, adAccountIdsForPractice) => {
    this.clearError()
    return updateAdAccountIdsForPractice(practiceId, adAccountIdsForPractice).then(res => {
      this.setState({ adAccountIdsForPractice: res })
      return Promise.resolve(res)
    })
  }

  getAndSaveAppointmentTypes = practiceId => {
    this.clearError()
    return getAppointmentTypes(practiceId).then(res => {
      this.setState({ appointmentTypes: res })
      return Promise.resolve(res)
    })
  }

  getAndSaveCarestreamCustomers = () => {
    this.clearError()
    return getCarestreamCustomers().then(res => {
      this.setState({ carestreamCustomers: res })
      return Promise.resolve(res)
    })
  }

  getAndSaveLocationList = () => {
    this.clearError()
    return getLocations(this.props.practiceId).then(res => {
      this.setState({
        locations: res,
      })
      return Promise.resolve(res)
    })
  }

  getAndSaveCustomMentionValues = () => {
    this.clearError()
    return getCustomMentionValues(this.props.practiceId).then(res => {
      this.setState({
        customMentionValuesByLocation: res,
      })
      return Promise.resolve(res)
    })
  }
  // step 4 on finish
  updateAllLocations = (contactInfoUpdates, extensionUpdates, customMentionValueUpdates) => {
    this.clearError()
    const dso = this.state.products.includes('dso')
    const voip = this.state.products.includes('voip')

    if (dso && voip) {
      this.updateAllLocationsExtensions(extensionUpdates)
    }
    if (customMentionValueUpdates && Object.keys(customMentionValueUpdates).length > 0) {
      this.updateAllCustomMentionValues(customMentionValueUpdates)
    }

    return this.updateAllLocationsContactInfo(contactInfoUpdates)
  }

  updateAllLocationsExtensions = updates =>
    updateExtensions(this.props.practiceId, updates)

  updateAllCustomMentionValues = (updates) => {
    Promise.all(
      Object.entries(updates).map(([locationId, locValues]) => {
        return updateCustomMentionValues(this.props.practiceId, locationId, locValues)
          .then(() => this.getAndSaveCustomMentionValues())
          .catch(err => this.handleApiError(err))
      })
    )
  }

  updateAllLocationsContactInfo = updates =>
    Promise.all(
      this.state.locations.map(({ id, name, country_code: countryCode }) => {
        const update = updates[id]
        const additionalRecipients = this.cleanRecipientList(
          update.additionalRecipients,
        )
        const messageReportEmails = this.cleanRecipientList(
          update.messageReportEmails,
        )
        if (!update) {
          return Promise.reject(
            new Error(`Location ${name} did not have any updates`),
          )
        }
        const {
          active,
          doctorId,
          fEmailEnd,
          fEmailStart,
          officeEmail,
          officePhone,
          outboundNumberId,  
        } = update
        const data = {
          active,
          additional_recipients: additionalRecipients,
          doctor_id: doctorId || null,
          forwarding_email:
            fEmailStart && fEmailEnd ? `${fEmailStart}@${fEmailEnd}` : '',
          message_report_recipients: messageReportEmails,
          office_email: officeEmail,
          office_phone: formatPhoneNumberForUpdate(officePhone, countryCode),
          external_outbound_number_id: outboundNumberId || null
        }
        return updateLocation(this.props.practiceId, id, data)
      }),
    )
      .then(() => this.getAndSaveLocationList())
      .then(() => {
        this.next()
      })
      .catch(err => this.handleApiError(err))

  cleanRecipientList = list =>
    list
      .split(',')
      .map(el => el.trim())
      .flat()
      .filter(el => el)

  createOrUpdateDoctor = (body, doctorId) => {
    this.clearError()
    const { practiceId } = this.props
    const requestPromise = doctorId
      ? updateDoctor(practiceId, doctorId, body)
      : createDoctor(practiceId, body)
    return requestPromise
      .then(() => this.getAndSaveDoctorsList())
      .catch(err => {
        this.handleApiError(err)
        return Promise.resolve()
      })
  }

  getAndSaveDoctorsList = () => {
    this.clearError()
    return getDoctors(this.props.practiceId).then(res => {
      this.setState({
        doctors: res,
      })
      return Promise.resolve(res)
    })
  }

  buyPhoneNumbers = (
    countryCode,
    areaCode,
    locationId,
    addressSID,
    bundleSID,
  ) => {
    this.clearError()
    return buyPhoneNumber(
      countryCode,
      areaCode,
      locationId,
      addressSID,
      bundleSID,
    )
      .then(() => this.getAndSaveLocationList())
      .catch((err) => {
        this.handleApiError(err)
      })
  }

  getPracticeAdmins = () => {
    const { practiceId } = this.props
    return getUsers(practiceId).then(res =>
      this.setState({
        users: this.filterPracticeAdmins(res),
      }),
    )
  }

  async createAdminUser(resourceId, email, role, password) {
    try {
      this.clearError()
      const { isTopsAdmin } = this.props
      await createAdmin(
        resourceId,
        isTopsAdmin ? { email, password } : { email },
        role,
      )
      this.getPracticeAdmins()
    } catch (err) {
      this.handleApiError(err)
    }
  }

  removePracticeAdmin = (userId) => {
    this.clearError()
    const { practiceId } = this.props
    return removeUser(practiceId, userId)
      .then(() => this.getPracticeAdmins())
      .catch((err) => {
        this.handleApiError(err)
        return Promise.resolve()
      })
  }

  async updateAdminUser(userId, updates) {
    try {
      this.clearError()
      const { practiceId } = this.props
      await updateAdmin(practiceId, userId, updates)
      this.getPracticeAdmins()
    } catch (error) {
      this.handleApiError(error)
    }
  }

  checkLocationInfo = () => {
    if (!this.state.locations) return false

    return this.state.locations.some(
      location =>
        this.checkLocationEmails(location) && this.checkLocationPhone(location),
    )
  }

  checkLocationEmails = location =>
    location.forwarding_email && location.office_email

  checkLocationPhone = location =>
    this.state.tier === 4 ||
    (location.phone_numbers &&
      location.phone_numbers.length >= 1 &&
      location.office_phone)

  filterPracticeAdmins = users =>
    users.filter(user => {
      if (user.role_names) {
        return (
          user.role_names.length === 1 &&
          user.role_names.some(
            role => role === 'practice_admin' || role === 'location_admin',
          )
        )
      }
      return true
    })

  editBusiness = (business, index) => {
    this.setState({
      businessArrayId: index,
      editingBusiness: business,
      isBusinessFormOpen: true,
    })
  }

  toggleBusinessForm = () => {
    this.setState(prevState => ({
      businessArrayId: null,
      editingBusiness: null,
      isBusinessFormOpen: !prevState.isBusinessFormOpen,
    }))
  }

  createOrUpdateBusiness = (body, businessId, businessArrayId) => {
    this.clearError()
    const { practiceId } = this.props
    if (!practiceId) {
      if (businessArrayId !== null) {
        const businesses = this.state.businesses
        businesses.splice(businessArrayId, 1)
        businesses.splice(businessArrayId, 0, body)
        this.setState({ businesses })
      } else {
        this.setState({
          businesses: [...this.state.businesses, body],
        })
      }
      return Promise.resolve()
    }
    const requestPromise = businessId
      ? updateBusiness(practiceId, businessId, body)
      : createBusiness(practiceId, body)
    return requestPromise
      .then(() => this.getAndSaveBusinessList())
      .catch(err => {
        this.handleApiError(err)
        return Promise.resolve()
      })
  }

  getAndSaveBusinessList = (newlySavedPractice = null) => {
    this.clearError()
    const practiceId = newlySavedPractice
      ? newlySavedPractice.id
      : this.props.practiceId
    return showPractice(practiceId).then(res => {
      this.setState({
        businesses: res.businesses,
      })
      return Promise.resolve(res)
    })
  }

  setStepStatus = (step, status) => {
    this.setState({
      [`stepStatus${step}`]: status,
    })
  }

  next = () => {
    this.clearError()
    const { history, match, location } = this.props
    if (location.pathname.match(/step-[1-5]$/)) {
      const nextLocation = {
        pathname: `${match.url}/step-${+location.pathname.match(/\d$/)[0] + 1}`,
      }
      history.push(nextLocation)
    }
  }

  prev = () => {
    const { history, match, location } = this.props
    if (location.pathname.match(/step-[1-5]$/)) {
      this.clearError()
      const nextLocation = {
        pathname: `${match.url}/step-${+location.pathname.match(/\d$/)[0] - 1}`,
      }
      history.push(nextLocation)
    }
  }

  finish = () => {
    newPracticeStorage.clear()
    this.props.history.push('/dashboard')
  }

  render() {
    const { match, location, practiceId, isTopsAdmin } = this.props
    const step = location.pathname.match(/step-[1-5]$/)
      ? +location.pathname.match(/\d$/)[0] - 1
      : 5
    const {
      additionalRecipients,
      appointmentTypes,
      businessArrayId,
      businesses,
      carestreamCustomers,
      customMentionValuesByLocation,
      doctors,
      editingBusiness,
      error,
      extensions,
      externalId,
      externalOutboundNumbers,
      isBusinessFormOpen,
      locations,
      messageReportEmail,
      pbxDomain,
      pbxNumber,
      pbxServiceType,
      pbxUsername,
      pbxVEmail,
      pms,
      practiceName,
      products,
      servicesCancelled,
      subdirectory,
      tier,
      users,
      website,
      adAccounts,
      adAccountIdsForPractice,
      greyfinchIntegrationComplete,
    } = this.state
    const schedulingClient = products.includes('openchair')
    const pmsAllowsOS = ['Cloud9', 'Dolphin', 'OpenDental'].includes(pms)
    const commonProps = {
      isTopsAdmin,
      practiceId,
      handleNamedInputChange: this.handleNamedInputChange,
      validateEmail: this.validateEmail,
      handleApiError: this.handleApiError,
      clearError: this.clearError,
      onBack: this.prev,
      setStepStatus: this.setStepStatus,
      currentStep: step,
    }

    return (
      <div className={css.content}>
        {servicesCancelled && (
          <Alert
            type="error"
            message="This Practice Has Cancelled Services"
            description={this.state.error}
          />
        )}
        <div className={css.practiceNameHeader}>
          <h2 className={css.practiceName}>{practiceId} - {practiceName}</h2>
          {practiceId && !isTopsAdmin && (
            <div className={css.cancelToggle}>
              <span className={css.cancelText}>
                Services Active (Toggle Off To Cancel All Services):
              </span>
              <Toggle
                onClick={this.toggleCancelled}
                checked={!servicesCancelled}
              />
            </div>
          )}
        </div>
        <Steps current={step} className={css.stepsBar}>
          {this.steps.map((item, ind) => (
            <Step
              key={item.title}
              title={item.title}
              status={this.state[`stepStatus${ind}`]}
            />
          ))}
        </Steps>
        <div className={css.stepContent}>
          {this.state.error && (
            <Alert
              showIcon
              type="error"
              message="Error"
              description={this.state.error}
            />
          )}
          {this.state.checksReady ? (
            <Switch>
              <Route
                path={`${match.url}/step-1`}
                render={props => (
                  <Practice
                    {...props}
                    {...commonProps}
                    businessArrayId={businessArrayId}
                    businesses={businesses}
                    createOrUpdateBusiness={this.createOrUpdateBusiness}
                    editBusiness={this.editBusiness}
                    editingBusiness={editingBusiness}
                    externalId={externalId}
                    isBusinessFormOpen={isBusinessFormOpen}
                    onNext={this.handleStep1Next}
                    practiceName={practiceName}
                    toggleBusinessForm={this.toggleBusinessForm}
                  />
                )}
              />
              <Route
                path={`${match.url}/step-2`}
                render={props =>
                  this.steps[0].completed() ? (
                    <Products
                      {...props}
                      {...commonProps}
                      additionalRecipients={additionalRecipients}
                      messageReportEmail={messageReportEmail}
                      onNext={this.handleStep2Next}
                      updatePmsInState={this.updatePmsInState}
                      onProductSelect={this.onProductSelect}
                      products={products}
                      pbxDomain={pbxDomain}
                      pbxNumber={pbxNumber}
                      pbxServiceType={pbxServiceType}
                      pbxUsername={pbxUsername}
                      pbxVEmail={pbxVEmail}
                      pms={pms}
                      subdirectory={subdirectory}
                      tier={tier}
                      unselectIneligibleProducts={
                        this.unselectIneligibleProducts
                      }
                      website={website}
                      adAccounts={adAccounts}
                      adAccountIdsForPractice={adAccountIdsForPractice}
                    />
                  ) : (
                    <Redirect to={`${match.url}/step-1`} />
                  )
                }
              />
              <Route
                path={`${match.url}/step-3`}
                render={props =>
                  this.steps[1].completed() ? (
                    <Users
                      {...props}
                      {...commonProps}
                      createAdmin={this.createAdminUser}
                      locations={locations}
                      onNext={this.next}
                      products={products}
                      removeUser={this.removePracticeAdmin}
                      updateAdmin={this.updateAdminUser}
                      users={users}
                    />
                  ) : (
                    <Redirect to={`${match.url}/step-2`} />
                  )
                }
              />
              <Route
                path={`${match.url}/step-4`}
                render={props =>
                  this.steps[2].completed() ? (
                    <Info
                      {...props}
                      {...commonProps}
                      appointmentTypes={appointmentTypes}
                      createOrUpdateLocation={this.createOrUpdateLocation}
                      createOrUpdateDoctor={this.createOrUpdateDoctor}
                      carestreamCustomers={carestreamCustomers}
                      doctors={doctors}
                      getAndSaveDoctorsList={this.getAndSaveDoctorsList}
                      getAndSaveLocationList={this.getAndSaveLocationList}
                      locations={locations}
                      onNext={this.next}
                      pms={pms}
                      schedulingClient={schedulingClient}
                      website={website}
                      greyfinchIntegrationComplete={greyfinchIntegrationComplete}
                    />
                  ) : (
                    <Redirect to={`${match.url}/step-3`} />
                  )
                }
              />
              <Route
                path={`${match.url}/step-5`}
                render={props =>
                  this.steps[3].completed() ? (
                    <Associations
                      {...props}
                      {...commonProps}
                      businesses={businesses}
                      buyPhoneNumbers={this.buyPhoneNumbers}
                      customMentionValuesByLocation={customMentionValuesByLocation}
                      doctors={doctors}
                      extensions={extensions}
                      externalOutboundNumbers={externalOutboundNumbers}
                      hasErrors={!!error}
                      locations={locations}
                      onFinish={this.finish}
                      onNext={this.updateAllLocations}
                      products={products}
                      pms={pms}
                      refetchLocations={this.getAndSaveLocationList}
                      showAdditionalRecipients={schedulingClient}
                      showDoctorSelect={schedulingClient && pmsAllowsOS}
                      tier={this.state.tier}
                    />
                  ) : (
                    <Redirect to={`${match.url}/step-4`} />
                  )
                }
              />
              <Redirect to={`${match.url}/step-5`} />
            </Switch>
          ) : (
            'Loading...'
          )}
        </div>
      </div>
    )
  }
}

export default AddPractice



// WEBPACK FOOTER //
// ./src/AddPractice/index.js